import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createBlock(_component_v_list_item, {
    class: _normalizeClass({ 'p-0': _ctx.noPadding })
  }, {
    prepend: _withCtx(() => [
      _createVNode(_component_Avatar, {
        class: "mr-3",
        src: _ctx.imageUrl,
        alt: _ctx.initials
      }, null, 8, ["src", "alt"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_list_item_title, { class: "d-flex align-center flex-wrap" }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.title), 1),
          (_ctx.initialsName)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "pli__initials text-xs font-bold ml-4",
                style: _normalizeStyle(_ctx.initialsStyle),
                textContent: _toDisplayString(_ctx.initials)
              }, null, 12, _hoisted_2))
            : _createCommentVNode("", true),
          (_ctx.initialsItemDoctors && _ctx.initialsItemDoctors.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.initialsItemDoctors, (doctor, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: index,
                  class: "pli__initials text-xs font-bold ml-2",
                  style: _normalizeStyle(_ctx.doctorStyle(doctor)),
                  title: doctor.doctor.name
                }, _toDisplayString(_ctx.$filters.initials(doctor.doctor.name)), 13, _hoisted_3))
              }), 128))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_list_item_subtitle, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$dayjs(_ctx.timestamp).format('hh:mm A | MMM D, YYYY')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}